/* Budli dynamic product-card badges.
   Reads data-* emitted by card-product.liquid, picks ONE-per-grid winners
   (Most Bought / Best Value / Just Added), injects pills, and flags the
   Best Value card for a standout treatment. No deps. */
(function () {
  var LABEL = { 'most-bought': '🔥 Most Bought', 'best-value': '💰 Best Value', 'just-added': '✨ Just Added' };

  function makeBadge(type) {
    var b = document.createElement('span');
    b.className = 'budli-badge budli-badge--' + type;
    b.textContent = LABEL[type];
    return b;
  }

  function processGrid(grid) {
    var slots = grid.querySelectorAll('.budli-badges[data-bdg]:not([data-bdg-done])');
    if (!slots.length) return;
    var cards = [];
    Array.prototype.forEach.call(slots, function (s) {
      s.setAttribute('data-bdg-done', '1');
      cards.push({
        el: s,
        disc: parseInt(s.getAttribute('data-bdg-discount'), 10) || 0,
        created: parseInt(s.getAttribute('data-bdg-created'), 10) || 0,
        sales: parseInt(s.getAttribute('data-bdg-sales'), 10) || 0,
        cond: s.getAttribute('data-bdg-cond') || ''
      });
    });

    var topSeller = null, bestValue = null, newest = null;
    cards.forEach(function (c) {
      if (c.sales > 0 && (!topSeller || c.sales > topSeller.sales)) topSeller = c;
      if (c.disc > 0 && c.cond !== 'preowned' && c.cond !== 'usable' && (!bestValue || c.disc > bestValue.disc)) bestValue = c;
      if (c.created > 0 && (!newest || c.created > newest.created)) newest = c;
    });

    var usedEls = [];
    function place(c, type) {
      if (!c || usedEls.indexOf(c.el) > -1) return;
      usedEls.push(c.el);
      c.el.appendChild(makeBadge(type));
      if (type === 'best-value') {
        var wrap = c.el.closest('.card-wrapper');
        if (wrap) wrap.classList.add('budli-bv-card');
      }
    }
    /* priority: Most Bought > Best Value (not on MB) > Just Added (not on MB/BV) */
    place(topSeller, 'most-bought');
    place(bestValue, 'best-value');
    place(newest, 'just-added');
  }

  function run() {
    var grids = document.querySelectorAll('#product-grid, .product-grid, .budli-tabbed-collections__track, .btt-track');
    Array.prototype.forEach.call(grids, processGrid);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', run);

  /* Collection filter/sort replaces #ProductGridContainer — observe ONLY that
     node (light), not the whole body, so scrolling never triggers work. */
  function watchGridContainer() {
    var c = document.getElementById('ProductGridContainer');
    if (!c || !('MutationObserver' in window)) return;
    new MutationObserver(function () { run(); }).observe(c, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchGridContainer);
  else watchGridContainer();
})();
